'use strict';
import get from 'lodash/get';
import isUndefined from 'lodash/isUndefined';
import {Observable} from 'rxjs/Observable';
import {ReplaySubject} from 'rxjs/ReplaySubject';
import 'rxjs/add/observable/combineLatest';
import 'rxjs/add/operator/delay';
import 'rxjs/add/operator/distinctUntilChanged';
import 'rxjs/add/operator/pairwise';
import 'rxjs/add/operator/take';
import React, {Component} from 'react';
import * as T from 'prop-types';
import {getRouter} from '../../../config/reducers/state';
import {
  getAssetRequirementList,
  getProjectRequirementList,
  getTemplateRequirementList,
} from '../../../requirements/reducers/state';
import {TaskType, isTaskType} from '../../enums/TaskType';
import {assetTasksStates, projectTasksStates, templateTasksStates} from '../../router-config';


export function TaskDetailsNavContainer(WrappedComponent) {
  return class TaskDetailsNavComponent extends Component {
    static propTypes = {
      taskType: isTaskType.isRequired,

      init: T.bool,
    };

    static defaultProps = {
      init: true,
    };

    static $inject = [
      '$ngRedux',
    ];

    constructor(props) {
      super(props);

      this.state = {
        doesRouterStateMatch: true,
      };

      if (props.init && !isUndefined(props.taskType)) {
        const rootState = TaskDetailsNavContainer.dependencies.$ngRedux.getState();
        const routerState = getRouter(rootState);
        const listState = TaskDetailsNavComponent.getStateAccessor(props.taskType)(rootState);
        // eslint-disable-next-line max-len
        this.state.doesRouterStateMatch = TaskDetailsNavComponent.doesRouterStateMatch(props, listState && listState.parentId, routerState);
      }
    }

    componentWillReceiveProps(nextProps) {
      this.props$.next(nextProps);
    }

    componentDidMount() {
      this.props$ = new ReplaySubject(1);
      this.props$.next(this.props);

      if (this.props.init) {
        this.initData();
      } else {
        this.initSubscription = this.props$
          .filter(props => props.init)
          .take(1)
          .subscribe(this.initData.bind(this));
      }
    }

    initData() {
      this.init = true;

      const props$ = this.props$
        .distinctUntilChanged(null, ({taskType, parentId}) => `${taskType}|${parentId}`);

      this.stateSubscription = Observable
        .combineLatest(
          props$,
          props$.switchMap(props =>
            TaskDetailsNavContainer.dependencies.$ngRedux.state$
              .map(TaskDetailsNavComponent.getStateAccessor(props.taskType))
              .map(state => state.parentId)
              .distinctUntilChanged()
          ),
          TaskDetailsNavContainer.dependencies.$ngRedux.state$
            .map(getRouter)
            .distinctUntilChanged(),
          (props, currentParentId, routerState) => ({
            doesRouterStateMatch: TaskDetailsNavComponent.doesRouterStateMatch(props, currentParentId, routerState),
          })
        )
        .delay(0)
        .subscribe(nextState => this.setState(nextState));
    }

    componentWillUnmount() {
      this.props$ = null;
      this.stateSubscription && this.stateSubscription.unsubscribe();
      this.initSubscription && this.initSubscription.unsubscribe();
    }

    render() {
      if (this.state.doesRouterStateMatch) {
        return (<WrappedComponent
          {...this.props}
        />);
      } else {
        return null;
      }
    }

    static doesRouterStateMatch(props, currentParentId, routerState) {
      if (get(routerState, 'currentState.name') === TaskDetailsNavComponent.getViewName(props.taskType)) {
        const parentId = get(routerState, 'currentParams.taskId');
        return props.parentId === parentId;

      } else {
        // if we are on any other view, continue to render the list as long as this list matches the redux state.
        return props.parentId === currentParentId;
      }
    }

    static getViewName(taskType) {
      switch (taskType) {
        case TaskType.TEMPLATE:
          return templateTasksStates.requirements;

        case TaskType.PROJECT:
          return projectTasksStates.requirements;

        case TaskType.ASSET:
          return assetTasksStates.requirements;

      }
    }

    static getStateAccessor(taskType) {
      switch (taskType) {
        case TaskType.TEMPLATE:
          return getTemplateRequirementList;

        case TaskType.PROJECT:
          return getProjectRequirementList;

        case TaskType.ASSET:
          return getAssetRequirementList;

      }
    }
  };
}

TaskDetailsNavContainer.$inject = [
  '$ngRedux',
];



// WEBPACK FOOTER //
// ./src/js/tasks/components/TaskDetailsNavContainer/TaskDetailsNavContainer.js